import React from 'react'
import {render} from 'react-dom'
import App from './components/App';

render(<App 
   enableToggle={window.ep22MapConfig.enableToggle} 
   branch={window.ep22MapConfig.branch}
   path={window.ep22MapConfig.path}
   mapPath={window.ep22MapConfig.mapPath}
   logoPath={window.ep22MapConfig.logoPath}
   highlight={window.ep22MapConfig.highlight}
   />, 
   document.querySelector('#ep22InteractiveMap'))



// WEBPACK FOOTER //
// ./src/index.js